export default "__VITE_ASSET__DwsMhNIH__"